import React from 'react';
import classnames from 'classnames';
import Link from 'next/link';
import { ProductLocalizedEntity } from 'src/modules/products';

import classes from './DropdownSuggestions.module.scss';
import { ThumbnailAndTitle } from 'src/modules/global/components/table/thumbnail-and-title/ThumbnailAndTitle';

export interface DropdownSuggestionsProps {
  products: ProductLocalizedEntity[];
  selectedIndex?: number;
  className?: string;
}

export const DropdownSuggestions = ({
  products,
  className,
  selectedIndex,
}: DropdownSuggestionsProps) => {
  return (
    <div className={classnames(classes.resultsContainer, className)}>
      {products.map((product, i) => {
        return (
          <Link
            href="/professionals/downloads/products/[slug]"
            as={`/professionals/downloads/products/${product.slug}`}
            key={product.id}>
            <span
              className={classnames(
                classes.resultContainer,
                selectedIndex === i && classes.resultContainerSelected
              )}>
              <ThumbnailAndTitle url={product.assets[0]?.file?.url} title={product.name} />
            </span>
          </Link>
        );
      })}
    </div>
  );
};
